import variableColors from "@/base/global/variables/figma.colors.json";
import variableTypography from "@/base/global/variables/figma.typography.json";

const fontSizeLG = variableTypography["BodyLargeFontSize"];
export const radioThemeToken: any = {
  //======================== COLOR ===============================/
  colorText: variableColors["ColorFigmaNeutralGrayscaleGray90"],
  colorTextDisabled: variableColors["ColorFigmaNeutralGrayscaleGray60Disabled"],
  dotColorDisabled: variableColors["ColorFigmaNeutralGrayscaleGray60Disabled"],
  colorBorder: variableColors["ColorFigmaNeutralGrayscaleGray40"],
  colorBgContainerDisabled: variableColors["ColorFigmaNeutralGrayscaleGray30"],
  colorPrimaryActive: variableColors["ColorFigmaComplementaryBlue50"],
  colorPrimaryBorder: variableColors["ColorFigmaComplementaryBlue50"],
  colorPrimaryHover: variableColors["ColorFigmaComplementaryBlue50"],
  colorDot: variableColors["ColorFigmaComplementaryBlue50"],
  colorBgDot: variableColors["ColorFigmaNeutralWhiteWhite100"],
  colorHoverBgContainer: variableColors["ColorFigmaComplementaryBlue10"],

  //========================= FONT =================================/
  lineHeight: fontSizeLG,
  fontFamily: variableTypography["BodyMediumFontFamily"],

  //========================= SIZE =================================/
  dotSize: parseInt(fontSizeLG) / 2,
  fontSizeLG: parseInt(fontSizeLG),
  controlHeight: 40,
  controlHeightLG: 48,
  controlHeightSM: 32,
};
